<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "./assets/custom-bootstrap.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";
@import "../node_modules/vue-simple-context-menu/dist/vue-simple-context-menu.css";
@import "../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
@import "../node_modules/jexcel/dist/jexcel.css";
@import url("https://fonts.googleapis.com/css?family=Oswald");
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.0/font/bootstrap-icons.css");
// @import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap");
// @import "./assets/components/fonts.scss";
@import "./assets/base.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue